import { z } from 'zod';

export const SiteSchema = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  state: z.string().optional().nullable(),
  zipCode: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
});

export type Site = z.infer<typeof SiteSchema>;
